/**
 * Cinematic intro → main handoff helpers (Sprint 6B).
 * Goal: one continuous experience — no white flashes, shared session/analytics.
 */

/**
 * CSS class applied to host stage during intro↔main remount to keep black frame.
 */
export var CINEMATIC_HANDOFF_CLASS = "ngp-host-cinematic-handoff";

/**
 * Decide mute for intro autoplay under browser policy.
 * @param {function} shouldMuteIntroForAutoplay
 * @returns {{ autoplay: boolean, muted: boolean }}
 */
export function cinematicIntroPlaybackOpts(shouldMuteIntroForAutoplay) {
  return {
    autoplay: true,
    muted: typeof shouldMuteIntroForAutoplay === "function"
      ? !!shouldMuteIntroForAutoplay()
      : true,
  };
}

/**
 * Build next React state for ending intro and starting main content.
 * Keeps playerKey bump (clean provider handoff) while session stays continuous.
 *
 * @param {object} prevState
 * @param {object} [session] PlaybackSession
 * @returns {object} partial state
 */
export function planIntroToMainHandoff(prevState, session) {
  if (session && typeof session.setIntroActive === "function") {
    session.setIntroActive(false);
  }
  if (session && typeof session.setPipelinePhase === "function") {
    session.setPipelinePhase("media_playback");
  }
  // Prefer unmuted main after intro. NextGenPlayer mute-retries if the browser
  // blocks audible autoplay — do not app-force muted merely because the intro
  // ended without a gesture (that locked refresh/hard-refresh sessions silent).
  var audioUnlocked = !!(prevState && prevState.sessionAudioUnlocked);
  return {
    playingCinematicIntro: false,
    introSkipVisible: false,
    playerKey: (prevState && prevState.playerKey ? prevState.playerKey : 0) + 1,
    cinematicHandoff: true,
    forceMutedMainAutoplay: false,
    sessionAudioUnlocked: audioUnlocked,
  };
}

/**
 * Clear handoff flag after main player reports ready.
 * @param {object} prevState
 * @returns {object}
 */
export function clearCinematicHandoff(prevState) {
  return {
    cinematicHandoff: false,
    forceMutedMainAutoplay: false,
  };
}

export default {
  CINEMATIC_HANDOFF_CLASS: CINEMATIC_HANDOFF_CLASS,
  cinematicIntroPlaybackOpts: cinematicIntroPlaybackOpts,
  planIntroToMainHandoff: planIntroToMainHandoff,
  clearCinematicHandoff: clearCinematicHandoff,
};
